import {
  Input,
  ContentChild,
  Directive,
  Renderer2,
  ElementRef,
} from "@angular/core";
import { Platform, IonText } from "@ionic/angular";
import * as _ from "lodash";

@Directive({
  selector: "[ionKreFormFloat]",
  host: {
    "(ionBlur)": "onBlur($event)",
    "(ionChange)": "onModelChange($event)",
    "(ionFocus)": "onfocus($event)",
  },
})
export class IonKreFormFloat {
  @Input() selectedColor = "";
  @Input() decimalNumber = -1; // 保留小数位数,默认不限制
  @Input() max = 6;
  @Input() floattype = "base"; // 固定整数取6位 base:兼容除流程外的数字精度显示，为base表示整数固定取6位
  @Input() allowminus = true; // 允许负数  -true 允许 -false 不允许
  @ContentChild(IonText, { static: false }) _ionInput: IonText;
  isblur = false;

  constructor(
    public el: ElementRef,
    renderer: Renderer2,
    public plt: Platform
  ) {}
  onfocus(e) {
    this.isblur = false;
  }
  onBlur(e) {
    this.isblur = true;

    if (e.currentTarget.value !== "" && !isNaN(e.currentTarget.value)) {
      let val: any = e.currentTarget.value;

      if (this.decimalNumber > -1) {
        val = Number(e.currentTarget.value).toFixed(this.decimalNumber);
      }
      e.currentTarget.value = val;
    } else {
      e.currentTarget.value = "";
    }
  }
  onModelChange(event) {
    if (this.isblur) return;
    let { value } = event.detail;
    if (value === 0) value = "";
    if (!_.isNumber(value)) {
      event.currentTarget.value = value;
    } else {
      event.currentTarget.value = value = this.checkValue(value);
    }
  }
  checkValue(event) {
    let oldValue = event;
    let mark = "";
    if (this.allowminus) {
      mark = event.charAt(0);
    }
    if (this.decimalNumber === 0) {
      if (_.isNumber(oldValue)) {
        oldValue = Number(oldValue).toFixed(0); //  保留整数
      } else {
        // oldValue = oldValue;
      }
    } else {
      oldValue = oldValue.replace(/[^\d\.]/g, ""); // 清除"数字"和"."以外的字符
    }
    let newValue: any = "";

    if (oldValue === ".") {
      newValue = "";
    } else if (oldValue.indexOf(".") >= 0) {
      if (this.floattype !== "base") {
        const index = event.indexOf(".");
        const opintInLast = event.lastIndexOf(".") === event.length - 1;
        const totlaLength =
          index !== -1 && !opintInLast ? this.max + 1 : this.max;
        event = totlaLength > 0 ? event.substr(0, totlaLength) : event;

        oldValue = oldValue.split(".");
        oldValue.length = 2;
        let floatLength = oldValue[1] ? oldValue[1].length : 0;
        floatLength =
          floatLength > this.decimalNumber ? this.decimalNumber : floatLength;
        const intPart =
          this.max > 0
            ? oldValue[0].substr(0, this.max - floatLength)
            : oldValue[0];

        if (this.decimalNumber === 0 || intPart.length >= this.max) {
          newValue = String(Math.abs(Number(intPart)));
        } else {
          const floatPart = floatLength
            ? oldValue[1].substr(0, floatLength)
            : oldValue[1].substr(0, 3);
          newValue = String(Math.abs(Number(intPart)) + "." + floatPart);
        }
      } else {
        if (this.decimalNumber > 0) {
          newValue =
            oldValue.split(".")[0].substr(0, 6) +
            "." +
            oldValue.split(".")[1].substr(0, this.decimalNumber);
        } else {
          newValue =
            oldValue.split(".")[0].substr(0, 6) +
            "." +
            oldValue.split(".")[1].substr(0);
        }
      }
    } else {
      if (this.floattype !== "base") {
        newValue = oldValue.substr(0, this.max);
      } else {
        newValue = oldValue.substr(0, 6);
      }
    }
    if (
      String(newValue).substr(0, 1) === "0" &&
      String(newValue).substr(1, 1) !== "."
    ) {
      newValue = "0";
    }
    if (this.allowminus && mark === "-") {
      event = `${mark}${newValue}`;
      newValue = `${mark}${newValue}`;
    } else {
      event = newValue;
    }
    return event;
  }
}
